import { useMemo } from 'react'
import { DashboardTypeNames } from 'features/dashboard/utils/hooks/useDashboardTypeName'
import { DashboardTypes } from 'features/Codes'
import { useDashboardTableSelector } from 'features/dashboard/utils/hooks/useDashboardTableSelector'
import CreateCampaignButton from 'features/dashboard/operation/createCampaign/CreateCampaignButton'
import CreateAdGroupButton from 'features/dashboard/operation/createAdGroup/CreateAdGroupButton'
import CreateKeywordButton from 'features/dashboard/operation/createKeyword/CreateKeywordButton'
import CreateCreativeButton from 'features/dashboard/operation/createCreative/CreateCreativeButton'
import { useSelector } from 'react-redux'
import HelpTooltip from 'components/tooltip/HelpTooltip'

const EmptyTable = () => {
  const {
    filter: { filters },
    common: { type, isHeavyUser },
    table: {
      campaignTable: { selectedIds: campaignIds },
      adGroupTable: { selectedIds: adGroupIds },
    },
  } = useSelector(state => state.dashboard)
  const { loaded } = useDashboardTableSelector()
  const name = DashboardTypeNames[type]
  const hasBottomConsonants = [
    DashboardTypes.CAMPAIGN,
    DashboardTypes.AD_GROUP,
  ].includes(type)
  const showRestrictionMessage = useMemo(
    () =>
      isHeavyUser &&
      !(campaignIds.length === 1 || adGroupIds.length > 0) &&
      [DashboardTypes.KEYWORD, DashboardTypes.CREATIVE].includes(type),
    [isHeavyUser, campaignIds, adGroupIds, type]
  )
  return (
    <div
      className="nodata_info"
      style={{
        width: '100%',
        height: '100%',
      }}>
      {loaded && (
        <div className="inner_tbl">
          {showRestrictionMessage ? (
            <>
              1개 이상의 광고그룹을 선택하거나 광고그룹 미선택시엔 1개의
              캠페인만 선택해주세요.
              <HelpTooltip>
                플랫폼에서 등록 가능한 기본 키워드 수를 초과하여 사용하고
                있습니다.
                <br />
                안내된 기준을 선택 후 사용할 수 있습니다.
              </HelpTooltip>
            </>
          ) : filters.length > 0 ? (
            '검색 결과가 없습니다.'
          ) : (
            <>
              등록한 {name}
              {hasBottomConsonants ? '이' : '가'} 없습니다.
              <br />
              {type === DashboardTypes.CAMPAIGN && (
                <CreateCampaignButton type="link" />
              )}
              {type === DashboardTypes.AD_GROUP && (
                <CreateAdGroupButton type="link" />
              )}
              {type === DashboardTypes.KEYWORD && (
                <CreateKeywordButton type="link" />
              )}
              {type === DashboardTypes.CREATIVE && (
                <CreateCreativeButton type="link" />
              )}
              를 선택하여 새로운 {name}
              {hasBottomConsonants ? '을' : '를'} 등록하세요.
            </>
          )}
        </div>
      )}
    </div>
  )
}
export default EmptyTable
